/**
 * extension-signal-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor Smith <tdsmith@safetyweb.org>
 */

import { ReplyVerifyingMessage } from "../general";
import { MessageTag } from "../message-tag";

export interface ExtensionPayload
{
  name : string;
  version : [number, number, number];
}

export class ExtensionSignalRequest<T extends ExtensionPayload>
extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_EXTENSION_SIGNAL;
  public static tag : MessageTag = MessageTag.REQ_EXTENSION_SIGNAL;

  public expectsReply () : boolean
  {
    return true;
  }

  /**
   * Construct a new {@link ExtensionSignalRequest}.
   */
  constructor (public payload : T)
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/collaboration/extension-signal-request.ts